import React from 'react';
import { connect } from 'react-redux';
import ReactPagination from 'react-js-pagination';

class Pagination extends React.PureComponent {
  handlePageChange = (pageNumber) => {
    const { dispatch } = this.props;
    dispatch({ type: 'SET_ORG_ACTIVE_PAGE', payload: pageNumber });
  };

  render() {
    const { organizationsList, organizationFilter, organizationActivePage } = this.props;

    const listLength = organizationsList.filter((org) => (
      organizationFilter
      && (!org.organization_name.toLowerCase().includes(organizationFilter.toLowerCase()))
        ? null : org
    )).length;

    return (
      <ReactPagination
        activePage={organizationActivePage}
        itemsCountPerPage={25}
        totalItemsCount={listLength}
        pageRangeDisplayed={5}
        innerClass="pagination justify-content-center"
        itemClass="page-item"
        linkClass="page-link"
        onChange={this.handlePageChange}
      />
    );
  }
}

const mapStateToProps = (store) => ({
  organizationsList: store.logos.organizationsList,
  organizationFilter: store.logos.organizationFilter,
  organizationActivePage: store.logos.organizationActivePage,
});

export default connect(mapStateToProps)(Pagination);
